import {postsApi} from "../api/posts";

export default (postId) => ({
    postId,
    posts: [],
    page: 1,
    totalPages: 0,
    loading: false,
    async onSliderPrev() {
        if (this.page !== 1) {
            this.page -= 1;
            await this.loadPosts();
        }
    },
    async onSliderNext() {
        if (this.page !== this.totalPages) {
            this.page += 1;
            await this.loadPosts();
        }
    },
    async loadPosts() {
        this.loading = true;
        const response = await postsApi.getPosts({
            perPage: this.$store.responsive.isDesktop || this.$store.responsive.isPhone ? 3 : 2,
            page: this.page,
            postNotIn: this.postId,
        });
        this.totalPages = response.pages;
        if (this.$store.responsive.isDesktop) {
            this.posts = response.data;
        } else {
            this.posts.push(...response.data);
        }
        this.loading = false;
    },
    onResize() {
        if (window.innerWidth !== this.windowWidth) {
            this.windowWidth = window.innerWidth;
            this.page = 1;
            this.posts = [];
            this.loadPosts();
        }
    },
    async init() {
        await this.loadPosts();
        this.windowWidth = window.innerWidth;
        addEventListener('resize', this.onResize.bind(this));
        setTimeout(() => {
            this.$dispatch('open-popup-form');
        }, 30000)
    }
});